import React from 'react';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Card, CardBody } from 'reactstrap';

//Componentes auxiliares:
import EmptyBadge from '../tools/components/EmptyBadge';
import HelpButton from '../layouts/mainLayout/components/HelpButton';
import ChecksFilterManager from '../tools/components/ChecksFilterManager';
import ProcessesResumeTable from '../components/processesRegistry/ProcessesResumeTable';

//Contenido del tour de ayuda:
import { processesRegistryTourConfig } from './tours/ProcessesRegistry';

//Scripts auxiliares:
import { forceUserLogout } from '../tools/scripts/userRelated';
import { getFilteredArray } from '../tools/scripts/arrayManagement';
import { registerAuditProcess } from '../tools/scripts/customFetching';
import { getSwalContentForRetryRequest, getSwalContentForCancelRequest, retryDownloadProcess, cancelDownloadProcess } from './common/downloadSourcesOperations';

import {
    getStatusButtonClassname, getStatusIconClassname, getDownloadSourceTitle,
    getTimelineDivClassname, getTimelineIconClassname, getStatusIconTitle,
    getProcessTitle, getDownloadStatusDescription, getDownloadStatusColor
} from './common/downloadSourcesRenderingFunctions';

class ProcessesRegistry extends React.Component {

    constructor() {
        super();

        this.state = {
            activeQuantity: 5,
            targetProcesses: [],
            downloadSources: [],
            originalProcesses: [],

            statusFilters: {},
            statusFilteringKey: "status",

            downloadSourcesFilters: {},
            downloadSourcesFilteringKey: "id",
        }
    }

    componentDidMount() {
        this.getProcessesFromBackend()
        this.props.changeRelatedNavbarButtons([
            <HelpButton tourContent={processesRegistryTourConfig} />
        ]);
    }

    render() { 
        let sortedDownloadSources = this.state.downloadSources;
        try { sortedDownloadSources = sortedDownloadSources.sort((a, b) => a.id > b.id ? 1 : b.id > a.id ? -1 : 0); }
        catch (error) { }

        const urlParams = new URLSearchParams(window.location.search);
        let targetDownloadSourceId = urlParams.get("source_id");

        return (
            <div className="content">
                <Row>
                    <Col xs="12" md="5" lg="4" xl="4">
                        <div data-tut="reactour__processesRegistry.sourcesFilterManager">
                            <ChecksFilterManager
                                title="Fuentes de descarga:"
                                managerKey={"processRegistry"}
                                initialFilter={targetDownloadSourceId}
                                filteringOptions={sortedDownloadSources}
                                originalData={this.state.originalProcesses}
                                filteringKey={this.state.downloadSourcesFilteringKey}
                                originalFilters={this.props.processRegistrySourcesFilters}
                                filteredDataCallback={this.updateFilteredProcessesBasedOnSource}

                                activeQuantity={this.state.activeQuantity}
                                totalRegisters={this.state.targetProcesses.length}

                                itemRendering={(item) => {
                                    return (
                                        <span>
                                            <b>{item.description.split(":")[0]}</b>
                                            {item.description.split(":")[1] ? ": " + item.description.split(":")[1] : null}
                                        </span>
                                    );
                                }} />
                        </div>

                        <div data-tut="reactour__processesRegistry.statusFilterManager">
                            <ChecksFilterManager
                                title="Estado de descarga:"
                                managerKey={"status"}
                                filteringOptions={this.getStatusTypes()}
                                originalData={this.state.originalProcesses}
                                filteringKey={this.state.statusFilteringKey}
                                originalFilters={this.props.processRegistryStatusFilters}
                                filteredDataCallback={this.updateFilteredProcessesBasedOnStatus}

                                activeQuantity={this.state.activeQuantity}
                                totalRegisters={this.state.targetProcesses.length}

                                itemRendering={(item) => {
                                    return (
                                        <React.Fragment>
                                            <span dangerouslySetInnerHTML={{ __html: getDownloadStatusDescription(item, true, false) }} />
                                            <EmptyBadge color={getDownloadStatusColor(item, false)} />
                                       </React.Fragment>
                                    );
                                }} />
                        </div>
                    </Col>

                    <Col xs="12" md="7" lg="8" xl="8">
                        <Card data-tut="reactour__processesRegistry.processesRegistryTable">
                            <CardBody>
                                <div className="card-without-scrollbar">
                                    <ProcessesResumeTable
                                        activeQuantity={this.state.activeQuantity}
                                        targetProcesses={this.state.targetProcesses}
                                        getProcessTitle={getProcessTitle}
                                        getStatusIconTitle={getStatusIconTitle}
                                        getStatusButtonClassname={getStatusButtonClassname}
                                        getStatusIconClassname={getStatusIconClassname}
                                        getDownloadSourceTitle={getDownloadSourceTitle}
                                        getTimelineDivClassname={getTimelineDivClassname}
                                        getTimelineIconClassname={getTimelineIconClassname}
                                        updateActiveQuantity={this.updateActiveQuantity}
                                        retryDownloadProcess={this.retryDownloadProcess}
                                        cancelDownloadProcess={this.cancelDownloadProcess} />
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }

    //Métodos operativos:
    retryDownloadProcess = (targetProcess, downloadSource) => {
        let swalContent = getSwalContentForRetryRequest(downloadSource);

        Swal.fire(swalContent)
            .then(result => {
                if (result.value) {
                    retryDownloadProcess(this.props, targetProcess, downloadSource, registerAuditProcess, () => {
                        this.getProcessesFromBackend();
                    });
                };
            });
    }

    cancelDownloadProcess = (targetProcess, downloadSource) => {
        let swalContent = getSwalContentForCancelRequest(downloadSource);

        Swal.fire(swalContent)
            .then(result => {
                if (result.value) {
                    cancelDownloadProcess(this.props, targetProcess, downloadSource, registerAuditProcess, () => {
                        this.getProcessesFromBackend();
                    });
                };
            });
    }
    
    getDownloadSourceById = (id, sources) => {
        for (let i = 0; i < sources.length; i++) {
            if (sources[i].id === id) {
                return sources[i];
            }
        }

        return {};
    }

    getProcessesFromBackend = () => {
        window.document.body.style.cursor = "wait";
        let sourcesRequest = fetch(process.env.REACT_APP_API_URL + "/sources/", {
            method: 'get',
            headers: { 'Authorization': 'Token ' + this.props.activeUser.authToken }
        })
        let processesRequest = fetch(process.env.REACT_APP_API_URL + "/processes/", {
            method: 'get',
            headers: { 'Authorization': 'Token ' + this.props.activeUser.authToken }
        });

        Promise.all([sourcesRequest, processesRequest])
            .then(serverResponses => {

                if (serverResponses[0].status === 200 && serverResponses[1].status === 200) {
                    let sourcesTransformRequest = serverResponses[0].json();
                    let processesTransformRequest = serverResponses[1].json();

                    Promise.all([sourcesTransformRequest, processesTransformRequest])
                        .then(responses => {
                            let sources = responses[0];
                            let processes = responses[1];

                            let formatedProcesses = [];
                            for (let i = 0; i < processes.length; i++) {
                                let temporalProcess = processes[i];
                                temporalProcess.linkedDownloadSource = this.getDownloadSourceById(processes[i].source_id, sources);
                                temporalProcess.description = this.getDownloadSourceById(processes[i].source_id, sources).description;

                                formatedProcesses.push(temporalProcess);
                            }

                            formatedProcesses = formatedProcesses.filter(item =>
                                item.linkedDownloadSource.country_scope === this.props.activeUser.country_scope);

                            sources = sources.filter(item => item.country_scope === this.props.activeUser.country_scope);

                            this.setState({
                                downloadSources: sources,
                                originalProcesses: formatedProcesses
                            });

                            window.document.body.style.cursor = "default";
                        })
                        .catch(error => { console.log(error); window.document.body.style.cursor = "default"; });
                }
                else {
                    if (serverResponses[0].status === 401 || serverResponses[1].status === 401) {
                        forceUserLogout();
                    }
                    else { console.log("Problema descargando los sources y los processses"); }
                }
            })
            .catch(error => { console.log(error); window.document.body.style.cursor = "default"; });
    }

    getStatusTypes = () => {
        return [
            { "status": 'SUCCESS' },
            { "status": 'IN_PROCESS' },
            { "status": 'WAITING_FOR_USER_ACTION' },
            { "status": 'ERROR' },
            { "status": 'CANCELLED' },
        ]
    }

    updateActiveQuantity = (newQuantity) => {
        this.setState({ activeQuantity: newQuantity });
    }

    updateFilteredProcessesBasedOnSource = (newFilters) => {
        let filteredItems = getFilteredArray(this.state.originalProcesses, newFilters, "source_id");
        filteredItems = getFilteredArray(filteredItems, this.state.statusFilters, "status");

        this.props.changeProcessRegistrySourcesFilters(newFilters);
        this.setState({ targetProcesses: filteredItems, downloadSourcesFilters: newFilters });
    }

    updateFilteredProcessesBasedOnStatus = (newFilters) => {
        let filteredItems = getFilteredArray(this.state.originalProcesses, newFilters, "status");
        filteredItems = getFilteredArray(filteredItems, this.state.downloadSourcesFilters, "source_id");

        this.props.changeProcessRegistryStatusFilters(newFilters);
        this.setState({ targetProcesses: filteredItems, statusFilters: newFilters });
    }
}

const mapdispatchToProps = dispatch => {
    return {
        changeRelatedNavbarButtons: (navbarButtons) => dispatch({ type: "changeNavbarButtons", navbarButtons: navbarButtons }),
        changeProcessRegistryStatusFilters: (newFilters) => dispatch({ type: "changeProcessRegistryStatusFilters", newProcessRegistryStatusFilters: newFilters }),
        changeProcessRegistrySourcesFilters: (newFilters) => dispatch({ type: "changeProcessRegistrySourcesFilters", newProcessRegistrySourcesFilters: newFilters }),
    };
};

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
        coreBackendHost: state.mainReducer.coreBackendHost,
        processRegistryStatusFilters: state.temporalsReducer.processRegistryStatusFilters,
        processRegistrySourcesFilters: state.temporalsReducer.processRegistrySourcesFilters
    };
};

export default connect(mapStateToProps, mapdispatchToProps)(withRouter(ProcessesRegistry));